import * as React from "react";

const HEFlag = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		x="0px"
		y="0px"
		width="25px"
		height="16px"
		viewBox="0 0 25 16"
		enableBackground="new 0 0 1250 800"
		xmlSpace="preserve"
		{...props}
	>
		<path fill="#FFFFFF" d="M0 0h25v16H0V0z" />
		<path fill="#0038B8" d="M0 1.5h25v2.5H0V1.5z" />
		<path fill="#0038B8" d="M0 12h25v2.5H0V12z" />
		<path
			fill="none"
			stroke="#0038B8"
			strokeWidth={0.55}
			d="M8.476 9.457h5.047L11 5.086L8.476 9.457zM11 10.914l2.524 -4.371H8.476L11 10.914z"
		/>
	</svg>
);

export default HEFlag;